import { Controller } from "stimulus";
import { DirectUpload } from "activestorage"
import axios from 'axios';

const whiteTheme = {
  'common.bi.image': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+P///38ACfsD/QVDRcoAAAAASUVORK5CYII=',
  'common.bisize.width': '251px',
  'common.bisize.height': '21px',
  'common.backgroundImage': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdj+P///38ACfsD/QVDRcoAAAAASUVORK5CYII=',
  'common.backgroundColor': '#fff',
  'common.border': '1px solid #c1c1c1',

  // header
  'header.backgroundImage': 'none',
  'header.backgroundColor': 'transparent',
  'header.border': '0px',

  // load button
  'loadButton.backgroundColor': '#fff; display: none',
  'loadButton.border': '1px solid #ddd',
  'loadButton.color': '#222',
  'loadButton.fontFamily': "'Noto Sans', sans-serif",
  'loadButton.fontSize': '12px',

  // download button
  'downloadButton.backgroundColor': 'rgb(66, 153, 225)',
  // 'downloadButton.backgroundColor': '#fdba3b',
  'downloadButton.border': '1px solid rgb(66, 153, 225)',
  'downloadButton.color': '#fff',
  'downloadButton.fontFamily': "'Noto Sans', sans-serif",
  'downloadButton.fontSize': '12px',

  // main icons
  'menu.normalIcon.color': '#8a8a8a',
  'menu.activeIcon.color': '#555555',
  'menu.disabledIcon.color': '#434343',
  'menu.hoverIcon.color': '#e9e9e9',
  'menu.iconSize.width': '24px',
  'menu.iconSize.height': '24px',

  // submenu icons
  'submenu.normalIcon.color': '#8a8a8a',
  'submenu.activeIcon.color': '#555555',
  'submenu.iconSize.width': '32px',
  'submenu.iconSize.height': '32px',

  // submenu primary color
  'submenu.backgroundColor': 'white',
  'submenu.partition.color': '#e5e5e5',

  // submenu labels
  'submenu.normalLabel.color': '#858585',
  'submenu.normalLabel.fontWeight': 'normal',
  'submenu.activeLabel.color': '#000',
  'submenu.activeLabel.fontWeight': 'normal',

  // checkbox style
  'checkbox.border': '1px solid #ccc',
  'checkbox.backgroundColor': '#fff',

  // rango style
  'range.pointer.color': '#333',
  'range.bar.color': '#ccc',
  'range.subbar.color': '#606060',

  'range.disabledPointer.color': '#d3d3d3',
  'range.disabledBar.color': 'rgba(85,85,85,0.06)',
  'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',

  'range.value.color': '#000',
  'range.value.fontWeight': 'normal',
  'range.value.fontSize': '11px',
  'range.value.border': '0',
  'range.value.backgroundColor': '#f5f5f5',
  'range.title.color': '#000',
  'range.title.fontWeight': 'lighter',

  // colorpicker style
  'colorpicker.button.border': '0px',
  'colorpicker.title.color': '#000',
};

const NAVBAR_EDITOR_HEIGHT = 250

export default class extends Controller {
  connect(){
    import(/* webpackChunkName: "tui-image-editor" */"tui-image-editor").then(({default: ImageEditor}) => {
      this.startEditor(ImageEditor)
    })
  }

  startEditor(ImageEditor){
    const modal = document.querySelector('#mainModal')
    if(modal){
      modal.removeAttribute('tabindex')
    }
    this.modal = modal
    this.instance = new ImageEditor(this.element, {
      includeUI: {
        theme: whiteTheme,
        initMenu: '',
        menu: ['crop', 'rotate', 'draw', 'shape', 'icon', 'text'],
        menuBarPosition: 'top',
        locale
      },
      cssMaxWidth: window.innerWidth * 1,
      cssMaxHeight: this.element.parentElement.clientHeight - NAVBAR_EDITOR_HEIGHT,
      usageStatistics: false,
    });

    this.instance.loadImageFromURL(
      this.element.dataset.url,
      this.data.get("filename")
    ).then(() => {
      this.instance.ui.activeMenuEvent()
      document.querySelector('.upload-editor__loading').classList.add('tw-hidden')
    }).catch(() => {
      toastr.error('Erro ao carregar imagem')
      console.error(arguments)
      Bugsnag.notify(arguments)

    });

    window.addEventListener('resize', (event) => {
      this.instance.ui.resizeEditor();
    }, true);

    const helpMenu = document.querySelector('.tui-image-editor-help-menu')
    helpMenu.classList.remove('bottom')
    helpMenu.classList.add('right')

    this.saveButtonLoading = document.querySelector('.upload-image-editor-save-loading')

    this.downloadButton = document.querySelector('.upload-image-editor-save')
    this.downloadButton.addEventListener('click', () =>{
      this.downloadButton.setAttribute('disabled', 'disabled')
      this.downloadButton.innerText = 'Aguarde...'
      fetch(this.instance.toDataURL()).then(response => response.blob()).then((file) => this.uploadImage(file))
    })
  }

  uploadImage(file){
    const url = this.data.get("directUploadsUrl")
    const upload = new DirectUpload(file, url)
    file.name = this.data.get("filename")

    upload.create((error, blob) => {
      const data = {
        upload: {
          file: blob.signed_id,
        }
      };
      data[this.data.get('csrf-name')] = this.data.get('csrf-token')
      if (error) {
        alert('error')
      } else {
          axios.put(
            this.data.get("uploadPath"),
            data, {
            headers: {
              "X-CSRF-Token": this.data.get('csrf-token'),
              'Content-Type': 'application/json'
            }
          })
            .then(() => {
              this.downloadButton.innerText = 'Salvar'
              this.downloadButton.removeAttribute('disabled')
              toastr.success('Imagem salva com sucesso!')
              $(this.modal).modal('hide')
              Turbolinks.visit(window.location.toString(), { action: 'replace' })
            })
            .catch(() => {
              this.downloadButton.innerText = 'Salvar'
              this.downloadButton.removeAttribute('disabled')
              toastr.error('Erro ao salvar imagem!')
            })
      }
    })
  }
}

const locale = {
  "Color": "Cor",
  "Bold": "Negrito",
  "Text": "Texto",
  "Left": "Esquerda",
  "Right": "Direita",
  "Center": "Centro",
  "Download": "Baixar",
  "Crop": "Recortar",
  "Italic": "Itálico",
  "Underline": "Sublinhado",
  "Rectangle": "Retângulo",
  "Circle": "Círculo",
  "Fill": "Preenchimento",
  "Stroke": "Borda",
  "Draw": "Desenho",
  "Free": "Livre",
  "Straight": "Reto",
  "Rotate": "Rotacionar",
  "Custom": "Personalizado",
  "Square": "Quadrado",
  "Apply": "Aplicar",
  "Cancel": "Cancelar",
  "Hand": "Arrastar",
  "Undo": "Desfazer",
  "Reset": "Limpar",
  "Shape": "Formas",
  "Icon": "Ícones",
  "Arrow": "Seta",
  "Arrow-2": "Seta 2",
}
